export default __webpack_public_path__ + "static/media/class_v_vi.66ecfc7d.png";